import { createContext, useContext } from 'react';
import { useNavigate } from 'react-router-dom';

// ── Portal preview ───────────────────────────────────────────────────────────
// Set by components/PortalPreview.js while an admin previews another user's
// portal inside the staff app. Holds:
//   navigate  — replaces react-router's navigate, so links inside the preview
//               move the preview, not the admin's page
//   supplier       — the supplier record being previewed
//   supplierViews  — views built with unsaved permissions (Suppliers page);
//                    null means read the supplier's real views

export const PreviewContext = createContext(null);

export function usePreview() {
  return useContext(PreviewContext);
}

/** react-router's navigate, or the preview's own while previewing. */
export function usePreviewNavigate() {
  const preview = useContext(PreviewContext);
  const navigate = useNavigate();
  return preview?.navigate || navigate;
}
